import { AppTabKey } from "@quote/types";
import { StateCreator } from "zustand";

import { AppState } from "./types";

const initState = {
  activeTab: AppTabKey.HOTEL_GOLF,
  hasFlight: false,
  preQuoteKey: "",
  preQuoteFlightKey: "",
};

export const createAppState: StateCreator<
  AppState,
  [["zustand/devtools", never]]
> = (set, get) => ({
  ...initState,

  appActions: {
    setActiveTab: (key: AppTabKey) => {
      set({ activeTab: key }, undefined, "app/setActiveTab");
    },
    setHasFlight: (hasFlight: boolean) => {
      set({ hasFlight }, undefined, "app/setHasFlight");
    },
    resetAppState: () => set(initState),

    setPreQuoteKey: (preQuoteKey) => {
      const { activeTab } = get();

      if (activeTab === AppTabKey.HOTEL_GOLF) {
        set({ preQuoteKey }, undefined, "app/setPreQuoteKey");
        return;
      }

      set(
        { preQuoteFlightKey: preQuoteKey },
        undefined,
        "app/setPreQuoteFlightKey",
      );
    },
  },

  appUtils: {
    getPreQuoteKey: () => {
      const { activeTab, preQuoteKey, preQuoteFlightKey } = get();

      return activeTab === AppTabKey.HOTEL_GOLF
        ? preQuoteKey
        : preQuoteFlightKey;
    },
  },
});
